import React from 'react';
import { useField } from 'informed';

export interface InformedFormVisitDateTimeFieldTypes {
  field: string;
}

export const InformedFormVisitDateTimeField = (
  props: InformedFormVisitDateTimeFieldTypes
) => {
  const { field } = props;
  const { render } = useField({
    field
  });
  return null;
};
